<div id="snackbar" [class]="utils.toastClass">{{ utils.toastMessage }}</div>
